'use client';

import { CustomImage } from 'components/shared/custom-image/CustomImage';
import { useModal } from 'components/shared/Modal';
import { PerformanceLabTFModal } from 'components/performance-lab/WaitlistTypeformModal';
import {
  HudAnnotation,
  useHudCycling,
} from 'components/performance-lab/HudAnnotations';
import { jetbrainsMono } from 'utils/fonts';
import styles from './waitlist-client.module.css';

const FRAME_POSITIONS = [
  { prefix: '010', left: '48%', top: '12%' },
  { prefix: '001', left: '85%', top: '15%' },
  { prefix: '110', left: '52%', top: '30%' },
  { prefix: '011', left: '80%', top: '33%' },
  { prefix: '101', left: '46%', top: '50%' },
  { prefix: '100', left: '78%', top: '52%' },
  { prefix: '001', left: '55%', top: '70%' },
  { prefix: '111', left: '82%', top: '75%' },
];

const MOBILE_FRAME_POSITIONS = [
  { prefix: '010', left: '5%', top: '48%' },
  { prefix: '101', left: '58%', top: '53%' },
  { prefix: '011', left: '8%', top: '72%' },
  { prefix: '110', left: '52%', top: '80%' },
];

const PerformanceLabWaitlist = () => {
  const { activeLabels, cycle } = useHudCycling(FRAME_POSITIONS.length);
  const { activeLabels: mobileLabels, cycle: mobileCycle } = useHudCycling(
    MOBILE_FRAME_POSITIONS.length,
    8000,
  );
  const ModalClient = useModal();

  const openWaitlistForm = () => {
    ModalClient.set(<PerformanceLabTFModal />);
    ModalClient.setCloseButtonTheme('light');
    ModalClient.show();
  };

  return (
    <>
      <main className={jetbrainsMono.variable}>
        <section className={styles.heroSection}>
          <div className={styles.contentLeft}>
            <h1 className={styles.heroHeading}>
              EXPERIENCE THE FUTURE OF HUMAN PERFORMANCE
            </h1>
            <button className={styles.waitlistCTA} onClick={openWaitlistForm}>Join the waitlist</button>
          </div>
          <div className={styles.imageRight}>
            <div className={styles.desktopImage}>
              <CustomImage
                src="web_v2/performance-lab/waitlist-page/particle-human.png"
                alt="Human performance visualization"
                fill
                style={{ objectFit: 'cover', objectPosition: 'center top' }}
                priority
              />
            </div>
            <div className={styles.mobileImage}>
              <CustomImage
                src="web_v2/performance-lab/waitlist-page/particle-human-mobile.png"
                alt="Human performance visualization"
                width={0}
                height={0}
                sizes="100vw"
                style={{ width: '100%', height: 'auto', display: 'block' }}
                priority
              />
            </div>
          </div>
          <div className={styles.desktopAnnotations}>
            {FRAME_POSITIONS.map((frame, i) => (
              <HudAnnotation
                key={i}
                label={activeLabels[i]}
                prefix={frame.prefix}
                left={frame.left}
                top={frame.top}
                delay={i * 0.2}
                cycle={cycle}
              />
            ))}
          </div>
          <div className={styles.mobileAnnotations}>
            {MOBILE_FRAME_POSITIONS.map((frame, i) => (
              <HudAnnotation
                key={i}
                label={mobileLabels[i]}
                prefix={frame.prefix}
                left={frame.left}
                top={frame.top}
                delay={i * 0.2}
                cycle={mobileCycle}
              />
            ))}
          </div>
        </section>
      </main>
    </>
  );
};

export default PerformanceLabWaitlist;
